import { KycActionTypes } from './kyc.model';
require('dotenv').config();

export const initialState = {
    applications: [],
    totalApplications: 0,
    // The application currently open for review, as the service returns it: the whole KYC document
    // plus the member it belongs to.
    detail: { application: {}, member: {} },
    // The last connection test. `tested` separates "not asked yet" from "asked and it failed" —
    // without it an untested console is indistinguishable from a broken one.
    connection: { tested: false },
    isLoading: false,
    isDetailLoading: false,
    isConnectionLoading: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case KycActionTypes.FETCH_KYC_REQUEST: {
            return {
                ...state,
                isLoading: true
            };
        }

        case KycActionTypes.FETCH_KYC_SUCCESS: {
            return {
                ...state,
                applications: action.payload.applications,
                totalApplications: action.payload.totalApplications,
                isLoading: false
            };
        }

        case KycActionTypes.FETCH_KYC_DETAIL_REQUEST: {
            // Cleared on the way out, not on the way in, so the dialog opens empty rather than
            // showing the previously reviewed member while this one loads.
            return {
                ...state,
                detail: { application: {}, member: {} },
                isDetailLoading: true
            };
        }

        case KycActionTypes.FETCH_KYC_DETAIL_SUCCESS: {
            return {
                ...state,
                detail: {
                    application: (action.payload || {}).application || {},
                    member: (action.payload || {}).member || {}
                },
                isDetailLoading: false
            };
        }

        case KycActionTypes.CLEAR_KYC_DETAIL: {
            return {
                ...state,
                detail: { application: {}, member: {} },
                isDetailLoading: false
            };
        }

        case KycActionTypes.FETCH_KYC_DETAIL_FAILURE: {
            return {
                ...state,
                isDetailLoading: false
            };
        }

        case KycActionTypes.FETCH_KYC_FAILURE: {
            return {
                ...state,
                isLoading: false
            };
        }

        case KycActionTypes.TEST_CONNECTION_REQUEST: {
            return {
                ...state,
                isConnectionLoading: true
            };
        }

        case KycActionTypes.TEST_CONNECTION_SUCCESS: {
            return {
                ...state,
                connection: { tested: true, ...(action.payload || {}) },
                isConnectionLoading: false
            };
        }

        case KycActionTypes.TEST_CONNECTION_FAILURE: {
            // The console's own API did not answer. Recorded as a failed test rather than left
            // looking untested, since that is exactly what an admin needs to see.
            return {
                ...state,
                connection: { tested: true, ok: false, reason: "The admin service did not answer" },
                isConnectionLoading: false
            };
        }

        default: {
            return state;
        }
    }
};

export { reducer as KycReducer };
